import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { routerActions } from "connected-react-router";
import { actions as accountsActions } from "reducers/accounts";
import { isEmpty } from "lodash";
import gaEventTracker, { events } from "util/gaEventTracker";

export const useAgreementSummary = () => {
    const { newAgreement, newAccountRequiredCredentials, newAgreementTicket } = useSelector((state) => state.accounts);
    const dispatch = useDispatch();
    const history = useHistory();
    const credentialType = newAccountRequiredCredentials.includes("otp") ? "otp" : "password";

    useEffect(() => {
        if (isEmpty(newAgreement)) {
            history.goBack();
            return;
        }
        dispatch(accountsActions.fetchCredentialGroup());
    }, [dispatch]);

    useEffect(() => {
        const { status, idTransaction } = newAgreementTicket;
        if (status === "PENDING" && idTransaction) {
            dispatch(routerActions.push(`/accounts/agreements/pendingTransaction/${idTransaction}`));
        }
        if (status === "FINISHED" && idTransaction) {
            dispatch(routerActions.push(`/accounts/agreements/successTransaction/${idTransaction}`));
        }
    }, [newAgreementTicket.status, newAgreementTicket.idTransaction]);

    const handleSubmit = ({ credential }, formikBag) => {
        const { idTransaction = "" } = newAgreement;
        gaEventTracker.triggerEvent(events.cuentas_nueva());

        if (idTransaction) {
            dispatch(
                accountsActions.setNewAgreementCredential(
                    {
                        idTransaction,
                        [`_${credentialType}`]: credential,
                    },
                    formikBag,
                    credentialType,
                ),
            );
        } else {
            dispatch(
                accountsActions.setNewAgreementCredential(
                    {
                        ...newAgreement,
                        [`_${credentialType}`]: credential,
                    },
                    formikBag,
                    credentialType,
                ),
            );
        }
    };

    const handleBack = useCallback(() => {
        dispatch(accountsActions.newAgreementShouldShowLastValues(true));
        history.goBack();
    }, [dispatch]);

    return { newAgreement, handleSubmit, credentialType, handleBack };
};
export default useAgreementSummary;
